import { useEffect, useState } from "react";
import { IoMdClose } from "react-icons/io";
import { IoCopyOutline } from "react-icons/io5";
import { MdArrowForwardIos } from "react-icons/md";
import m1 from "../../../../Assets/Images/defaultMedia1.jpeg";
import m2 from "../../../../Assets/Images/defaultMedia2.jpeg";
import m3 from "../../../../Assets/Images/defaultMedia3.jpeg";
import m4 from "../../../../Assets/Images/defaultMedia4.jpeg";
import { HiOutlineSpeakerWave } from "react-icons/hi2";
import { IoColorPaletteOutline } from "react-icons/io5";
import { RiImageEditLine } from "react-icons/ri";
import { GoTrash } from "react-icons/go";
import { MdBlock } from "react-icons/md";
import profileImage from "../../../../Assets/Images/user.png";
import {
  deleteApiCaller,
  getApiCaller,
  postApiCaller,
} from "../../../../Libs/apiCaller";
import { toast } from "react-toastify";
import Modal from "../../../../Components/Modals/Modall";
import { FadeLoader } from "react-spinners";
import { FaFileVideo } from "react-icons/fa";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const isImageFile = (url) => {
  const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp"];
  const videoExtensions = [".mp4", ".webm", ".mov", ".avi", ".mkv"];

  const lowerUrl = url.toLowerCase();

  // Check if URL contains image extension
  if (imageExtensions.some((ext) => lowerUrl.includes(ext))) {
    return true;
  }

  // Check if URL contains video extension
  if (videoExtensions.some((ext) => lowerUrl.includes(ext))) {
    return false;
  }
  // Default to image if no extension matches
  return true;
};

export default function ContactInfo({
  totalMedia,
  isMediaLoading,
  mediaList,
  setActiveSection,
  setShowProfileView,
  activeChat,
  setActiveChat,
  settings,
  setSettings,
  chatConversationId,
  setAllMessages,
  setChatUsers,
  getMediaList,
}) {
  const { socket } = useSelector((state) => state.socket);
  const navigate = useNavigate();
  const [isMuted, setIsMuted] = useState(false);
  const [chatColor, setChatColor] = useState("#7104F8"); // default blue
  const [bgColor, setBgColor] = useState("#f3f4f6"); // default gray
  const [timeoutId, setTImeoutId] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [blockModal, setBlockModal] = useState(false);
  const [unblockModal, setUnblockModal] = useState(false);
  const [isBlock, setIsBlock] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [commonGroups, setCommonGroups] = useState([]);
  const uid = localStorage.getItem("userId");

  const handleCopy = () => {
    navigator.clipboard.writeText(
      `${activeChat?.user?.countryCode} ${activeChat?.user?.phone}`
    );
    toast.success("Number copied to clipboard!");
  };

  const [showNotif, setShowNotif] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setShowNotif(true);
    }, 50);
  }, []);

  useEffect(() => {
    getCommonGroups();
  }, []);

  const getCommonGroups = async () => {
    setIsLoading(true);
    const endpoint = `group/common-group/${activeChat?.user?._id}`;
    const response = await getApiCaller(endpoint);
    if (response?.status === 200) {
      setCommonGroups(response.data.data);
    } else {
      toast.error(response?.response?.data?.message || response.message);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (settings) {
      setChatColor(settings.chatColor);
      setBgColor(settings.background);
      setIsMuted(settings.muteNotification);
    }
  }, [settings]);

  useEffect(() => {
    if (activeChat) {
      setIsBlock(Boolean(activeChat?.user?.isBlocked));
    }
  }, [activeChat, uid]);

  const handleSettingsChange = async (
    chtColor = chatColor,
    bgClr = bgColor,
    isMtd = isMuted
  ) => {
    const endpoint = `setting/add`;
    await postApiCaller(endpoint, {
      chatColor: chtColor,
      background: bgClr,
      muteNotification: isMtd,
      chatId: activeChat._id,
    });

    setSettings({
      chatColor: chtColor,
      background: bgClr,
      muteNotification: isMtd,
    });
  };

  const deleteUserChat = async () => {
    if (!chatConversationId._id) {
      setDeleteModal(false);
      return;
    }
    const endpoint = `messages/allChat/${chatConversationId._id}`;
    const response = await deleteApiCaller(endpoint);
    if (response?.status === 200) {
      setChatUsers((prev) =>
        prev.map((user) =>
          user.conversationId._id === chatConversationId._id
            ? { ...user, latestMessage: {} }
            : user
        )
      );
      setAllMessages([]);
      getMediaList();
      toast.success("Chat deleted successfully");
      setDeleteModal(false);
    } else {
      toast.error(response?.response?.data?.message || response.message);
    }
  };

  const blockUser = async () => {
    if (!activeChat) {
      setBlockModal(false);
      return;
    }
    const endpoint = `users/block/${activeChat?.user?._id}`;
    const response = await postApiCaller(endpoint);
    if (response?.status === 200) {
      setActiveChat((prev) => ({
        ...prev,
        user: {
          ...prev.user,
          isBlocked: true,
        },
      }));
      setChatUsers((prev) =>
        prev.map((chat) => {
          if (chat.user._id == activeChat?.user?._id) {
            chat.user.isBlocked = true;
          }
          return chat;
        })
      );
      socket.emit("disconnectConversation", { id: chatConversationId._id });
      toast.success("User blocked successfully");
      setBlockModal(false);
    }
  };

  const unblockUser = async () => {
    if (!activeChat) {
      setUnblockModal(false);
      return;
    }

    const endpoint = `users/unblock/${activeChat?.user?._id}`;
    const response = await postApiCaller(endpoint);
    if (response?.status === 200) {
      setActiveChat((prev) => ({
        ...prev,
        user: {
          ...prev.user,
          isBlocked: false,
        },
      }));
      setChatUsers((prev) =>
        prev.map((chat) => {
          if (chat.user._id == activeChat?.user?._id) {
            chat.user.isBlocked = false;
          }
          return chat;
        })
      );
      socket.emit("joinConversation", { id: chatConversationId._id });
      toast.success("User unblocked successfully");
      setUnblockModal(false);
    }
  };

  const downloadFile = (url) => {
    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    a.download = url;
    a.click();
  };

  return (
    <>
      <section>
        <div className="sticky  w-full min-h-[67px] py-3.5 bg-white dark:bg-slate-900 flex items-center justify-between border-b border-zinc-200 dark:border-slate-700  text-black dark:text-zinc-100 p-4 text-center">
          <div className="">
            <div className="w-full items-center bg-white dark:bg-slate-900 text-black dark:text-zinc-100 flex gap-4 ">
              <IoMdClose
                onClick={() => setShowProfileView(false)}
                className="cursor-pointer hover:text-[var(--primary-color)] h-8 w-8 p-1 border rounded-md"
              />
              <h1 className="text-lg font-semibold text-center ">
                Contact Info
              </h1>
            </div>
          </div>
        </div>
        <div className="bg-[#f9f6fe] justify-center h-[calc(100vh-80px)] min-h-[calc(100vh-80px)] max-h-[calc(100vh-80px)] gap-2 overflow-y-auto overflow-x-hidden">
          <div className="bg-white dark:bg-slate-800 pb-4 rounded-b-lg">
            <div className="profile-section p-4 pt-6 rounded-xl max-w-md flex flex-col justify-center items-center text-center gap-4">
              <div className="avatar">
                <div className="w-[160px] h-[160px] rounded-full">
                  <img
                    src={
                      activeChat?.user?.mediaUrl ||
                      activeChat?.user?.avtarImage ||
                      profileImage
                    }
                    alt="profile"
                    className="object-cover rounded-full"
                  />
                </div>
              </div>
              <div className="justify-items-center">
                <h2 className="text-lg font-semibold text-black pt-1 truncate max-w-xs">
                  {activeChat?.user?.name}
                </h2>
                <div className="flex pt-2 items-center gap-2 text-sm text-base-content opacity-70">
                  <span className="text-black font-normal">
                    (
                    {activeChat?.user?.countryCode?.includes("+")
                      ? activeChat?.user?.countryCode
                      : `+${activeChat?.user?.countryCode}`}
                    ) {activeChat?.user?.phone}
                  </span>
                  <button onClick={handleCopy} className="hover:text-primary">
                    <IoCopyOutline className="text-[var(--primary-color)] font-bold w-5 h-5 " />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="my-1 bg-white dark:bg-slate-800 pb-4 rounded-lg p-4">
            <h3 className="text-sm font-normal text-[#7C7C7C] mb-1">About</h3>
            <p className="text-[15px] text-black font-semibold">
              {activeChat?.user?.about}
            </p>
          </div>

          <div className="my-1 bg-white dark:bg-slate-800 pb-4 py-6 rounded-lg p-4">
            <div className="flex items-center justify-between">
              <h3 className="text-sm font-normal text-[#7C7C7C] mb-1">
                Media, Links & Documents
              </h3>
              <div onClick={() => setActiveSection("media")}>
                <h3 className="hover:underline cursor-pointer hover:text-[var(--primary-color)] text-sm flex items-center gap-1 font-normal text-[#7C7C7C] mb-1">
                  {totalMedia}
                  <MdArrowForwardIos className="group-hover:text-[var(--primary-color)]" />
                </h3>
              </div>
            </div>

            <div className="flex gap-5 mt-2">
              {isMediaLoading ? (
                <div className="flex items-center justify-center w-full h-full">
                  <FadeLoader color="#7104F8" loading={true} size={12} />
                </div>
              ) : mediaList.length > 0 ? (
                mediaList.slice(0, 4).map((msg, index) => (
                  <div
                    key={index}
                    className="min-w-[80px] min-h-[80px] rounded-xl overflow-hidden cursor-pointer"
                    onClick={() =>
                      isImageFile(msg.mediaUrl) && downloadFile(msg.mediaUrl)
                    }
                  >
                    {msg.mediaId.fileType === "video" ? (
                      <video
                        controls
                        src={msg.mediaUrl}
                        className="h-[80px] object-contain"
                      />
                    ) : (
                      <img
                        src={msg.mediaUrl}
                        alt={`media-${index}`}
                        className="h-[80px] w-full object-cover"
                      />
                    )}
                  </div>
                ))
              ) : (
                <div className="flex items-center justify-center h-full">
                  <p className="text-gray-500">No media found</p>
                </div>
              )}
            </div>
          </div>

          <div className="my-1 bg-white dark:bg-slate-800 pb-4 py-6 rounded-lg p-4">
            {/* Mute Notification */}
            <div className="flex justify-between items-center">
              <div>
                <p className="flex items-center gap-2 text-black font-semibold">
                  <HiOutlineSpeakerWave className="text-xl" /> Mute
                  Notifications
                </p>
              </div>
              <div>
                <label for="toggle" class="flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    checked={isMuted}
                    onChange={(ev) => {
                      setIsMuted(ev.target.checked);
                      if (timeoutId) {
                        clearTimeout(timeoutId);
                      }
                      setTImeoutId(
                        setTimeout(() => {
                          handleSettingsChange(
                            chatColor,
                            bgColor,
                            ev.target.checked
                          );
                        }, 500)
                      );
                    }}
                    id="toggle"
                    class="sr-only peer"
                  />
                  <div
                    className={`${showNotif ? "block" : "hidden"
                      } relative w-14 h-7 p-1 rounded-full before:absolute before:bg-white before:w-5 before:h-5 before:p-1 before:rounded-full before:transition-all before:duration-500 before:left-1 peer-checked:before:left-8 peer-checked:before:bg-white ${isMuted
                        ? "bg-[linear-gradient(131.7deg,_#7404FE_3.53%,_#42058E_133.97%)]"
                        : "bg-[#E5E7EB]"
                      }`}
                  ></div>
                </label>
              </div>
            </div>

            {/* Custom Chat Color Picker */}
            {/* <div className="flex justify-between items-center pt-3">
              <p className=" flex items-center gap-2 text-black font-semibold">
                <IoColorPaletteOutline className="text-xl" />
                Custom Chat Color
              </p>
              <div className="flex items-center gap-2">
                <input
                  type="color"
                  value={chatColor}
                  onChange={(e) => {
                    setChatColor(e.target.value);
                    if (timeoutId) {
                      clearTimeout(timeoutId);
                    }
                    setTImeoutId(
                      setTimeout(() => {
                        handleSettingsChange(e.target.value, bgColor, isMuted);
                      }, 500)
                    );
                  }}
                  className="w-7 cursor-pointer rounded-xl h-8 border-none bg-transparent"
                />
              </div>
            </div> */}

            {/* Custom Background Color Picker */}
            <div className="flex justify-between items-center pt-2">
              <p className="flex items-center gap-2 text-black font-semibold">
                <RiImageEditLine className="text-xl" />
                Custom Background Color
              </p>
              <div className="flex items-center gap-2">
                <input
                  type="color"
                  value={bgColor}
                  onChange={(e) => {
                    setBgColor(e.target.value);

                    if (timeoutId) {
                      clearTimeout(timeoutId);
                    }
                    setTImeoutId(
                      setTimeout(() => {
                        handleSettingsChange(
                          chatColor,
                          e.target.value,
                          isMuted
                        );
                      }, 500)
                    );
                  }}
                  className="w-7 cursor-pointer rounded-xl h-8 border-none bg-transparent"
                />
              </div>
            </div>
          </div>
          <div className="my-1 bg-white dark:bg-slate-800 pb-4 py-6 rounded-lg p-4 space-y-5">
            <h3 className="text-sm font-normal text-[#7C7C7C] mb-1">
              {commonGroups?.length === 0
                ? "No group in common"
                : `${commonGroups?.length} ${commonGroups?.length === 1 ? "Group" : "Groups"
                } in common`}
            </h3>

            {/* The Dream Team Group */}
            {isLoading ? (
              <div className="flex items-center justify-center w-full h-full">
                <FadeLoader color="#7104F8" loading={true} size={12} />
              </div>
            ) : (
              commonGroups?.map((group) => (
                <div
                  className="flex items-center cursor-pointer space-x-2"
                  onClick={() => {
                    navigate("/groups", {
                      state: { groupId: group._id },
                    });
                  }}
                >
                  {/* Circle Image Placeholder */}
                  <div
                    className={`${group?.groupImage
                      ? "w-12 h-12 max-w-[14] min-w-[12] max-h-[12] min-h-[12] bg-gray-200 rounded-full object-cover object-center"
                      : "object-cover max-w-[14] min-w-[12] p-1 rounded-full"
                      }`}
                  >
                    <img
                      src={group?.groupImage || profileImage}
                      alt={group?.groupName}
                      className="rounded-full w-12 h-12 object-cover object-center p-1"
                    />
                  </div>
                  <div className="">
                    <p className=" text-black font-semibold text-[15px]">
                      {group?.groupName}
                    </p>
                    <p className="text-xs text-gray-500 pt-1.5 line-clamp-1 overflow-hidden text-ellipsis break-words">
                      {group?.members
                        ?.slice(0, 4)
                        ?.map((member) => member)
                        .join(", ")}
                    </p>
                  </div>
                </div>
              ))
            )}
          </div>
          <div className="my-1 bg-white dark:bg-slate-800 pb-4 py-6 rounded-lg p-4 space-y-5">
            <div className="flex justify-between items-center">
              <div
                className="cursor-pointer"
                onClick={() => setDeleteModal(true)}
              >
                <p className="flex items-center gap-2 text-[#F44336] font-semibold hover:opacity-55">
                  <GoTrash className="text-xl text-[#F44336]" />
                  Delete Chat
                </p>
              </div>
            </div>

            <div className="flex justify-between items-center">
              <div
                className="cursor-pointer"
                onClick={() => {
                  if (isBlock) {
                    setUnblockModal(true);
                  } else {
                    setBlockModal(true);
                  }
                }}
              >
                <p className="flex items-center gap-2 text-[#F44336] font-semibold hover:opacity-55">
                  <MdBlock className="text-xl text-[#F44336]" />
                  {isBlock ? "Unblock" : "Block"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Modal
        isOpen={deleteModal}
        onClose={() => setDeleteModal(false)}
        onConfirm={deleteUserChat}
        description="Are you sure you want to delete this chat?"
        title="Delete Chat"
      />
      <Modal
        isOpen={blockModal}
        onClose={() => setBlockModal(false)}
        onConfirm={blockUser}
        description="Are you sure you want to block this user?"
        title={`Block User`}
      />
      <Modal
        isOpen={unblockModal}
        onClose={() => setUnblockModal(false)}
        onConfirm={unblockUser}
        description="Are you sure you want to unblock this user?"
        title={`Unblock User`}
      />
    </>
  );
}
